import { Button, Css } from "@homebound/beam";
import { ObjectState } from "@homebound/form-state";
import { baseDownloadUrl } from "src/context";
import { fail, queryResult } from "src/utils";
import { openInSelf } from "src/utils/window";
import { PlanBasedBidPackageFormState } from "../utils";
import { usePlanBasedBidPackageReviewAndDownloadStepQuery } from "./3.ReviewAndDownloadStep.generated";
import { PlanBasedBidsTableV2 } from "./PlanBasedBidsTableV2";

type ReviewAndDownloadStepProps = { formState: ObjectState<PlanBasedBidPackageFormState> };

export function ReviewAndDownloadStep(props: ReviewAndDownloadStepProps) {
  const query = usePlanBasedBidPackageReviewAndDownloadStepQuery({
    variables: { bidPackageId: props.formState.bidPackageId.value ?? fail("bidPackageId is required") },
  });
  return (
    <div css={Css.df.fdc.mb8.$}>
      <div css={Css.df.fdc.aic.mt6.mb2.$}>
        <div css={Css.xl2.mb2.$}>Review Bid</div>
        <div css={Css.mb1.tac.$}>
          Preview the cost lines below. Return to Step 2 to make changes before creating. After creating, you can edit
          <br />
          the bid or download the bid sheet anytime.
        </div>
      </div>
      {queryResult(query, ({ bidPackage }) => (
        <>
          <div css={Css.mla.mb1.$}>
            <Button
              icon="download"
              label="Download Bidsheet"
              onClick={() => downloadPlanBasedBidPackageV2(bidPackage.id)}
              variant="secondaryBlack"
              size="md"
            />
          </div>
          <PlanBasedBidsTableV2 bidPackage={bidPackage} />
        </>
      ))}
    </div>
  );
}

export function downloadPlanBasedBidPackageV2(bidPackageId: string) {
  const params = new URLSearchParams({ type: "planBasedBidPackageV2", bidPackageId });
  openInSelf(`${baseDownloadUrl()}/xlsx?${params.toString()}`);
}
